import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './CharacterCounter.module.scss';
export const GetCharacterCounterTID = (parentTestId)=>getTestIds(parentTestId);
export const DEFAULT_WARN_RATIO = 0.8;
export const CharacterCounter = (param)=>{
    let { value, max, warnAbove, testId } = param;
    const { CharacterCounterTestIds } = useMemo(()=>GetCharacterCounterTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('components.characterCounter');
    const count = [
        ...value
    ].length;
    const effectiveWarnAbove = warnAbove !== null && warnAbove !== void 0 ? warnAbove : Math.floor(max * DEFAULT_WARN_RATIO);
    const colorClass = count > max ? styles.danger : count > effectiveWarnAbove ? styles.warning : styles.success;
    return /*#__PURE__*/ _jsx(Box, {
        as: "span",
        testId: CharacterCounterTestIds.Root(),
        className: colorClass,
        "aria-live": "polite",
        "aria-label": t.ariaLabel({
            count,
            max
        }),
        children: "".concat(count, "/").concat(max)
    });
};
